// Module
var code = "<h3 id=\"oy-kullanma\">Oy Kullanma</h3> <p>BitShares&#39;de oy kullanmak ağın hem gelişmesi hem de güvenliği için önemlidir. Eğer dilerseniz oy kullanma hakkınızı sizin için oy kullanabilecek bir vekile devredebilirsiniz. Eğer vekil tayin ederseniz, manuel oylama etkisiz hale getirilecektir.</p> ";
// Exports
export default code;